import * as React from 'react'
import { connect } from 'react-redux'
import { InternetListComponent } from './InternetList'
import { replace } from 'react-router-redux'
import { reduxForm } from 'redux-form'
import { flow, get } from 'lodash'

export interface IInternetListContainerProps {
  page: number
}

const formName = 'internetList'

const stateToProps = ({ form }) => ({
  formData: get(form, [formName, 'values'], {}),
})

export const dispatchToProps = {
  replace,
}

export const InternetList = flow<any, any, React.SFC<IInternetListContainerProps>>(
  reduxForm({ form: formName, enableReinitialize: true }),
  connect(stateToProps, dispatchToProps)
)(InternetListComponent)



// WEBPACK FOOTER //
// src/features/Internet/InternetList/InternetList.container.ts